/**
 * Chaves de cookie / sessionStorage / localStorage usadas pelo auth.
 * Centralizadas pra evitar typos e facilitar grep "onde isso é lido/escrito".
 */

/** Cookie cross-subdomain (.runnaflow.com) com tokens admin durante impersonação. */
export const IMPERS_STASH_COOKIE = 'runna_impers_stash_v3'

/**
 * Flag per-tab (sessionStorage) que indica que ESTA aba é a aba impersonando.
 * Cookie stash é cross-subdomain; sem flag, não dá pra distinguir aba admin
 * origem (só escreveu o cookie) da aba target (consumiu o token).
 */
export const IMPERS_ACTIVE_TAB_KEY = 'runna_impers_active_tab'

/** Persona escolhida pelo user (demo mode / persona switcher). */
export const IMPERS_LS_PERSONA_KEY = 'runna_persona'

/** Marker per-tab de god mode ativo (set por ?tenant=X no primeiro load). */
export const GOD_MODE_SESSION_KEY = 'runna_god_mode_active'

/** Flag pra evitar loop de cleanup órfão em PlatformAdminGate. */
export const ORPHAN_CLEANUP_KEY = 'runna_orphan_cleanup'
